#patients-numerator
